import StandardModal from 'modals/StandardModal';

import './SanbornInfoModal.css';

const SanbornInfoModal = ({ options }) => {
	const { propertyData, zoningData } = options;

	return (
		<StandardModal
			title="Sanborn Map Information"
			closeOnOutsideClick
			noFooter
			size="md"
		>
			<div className="sanborn-info-modal">
				<div className="alert alert-info" role="alert">
					<strong>Sanborn maps aren't available outside of Manhattan.</strong>
				</div>

				{(zoningData?.sanborn || propertyData?.sanborn_volume || propertyData?.sanborn_page) && (
					<div className="sanborn-details">
						<h6>Sanborn Information:</h6>
						<ul className="list-unstyled">
							{zoningData?.sanborn && (
								<li><strong>Sanborn Map #:</strong> {zoningData.sanborn}</li>
							)}
							{propertyData?.sanborn_volume && (
								<li><strong>Sanborn Volume:</strong> {propertyData.sanborn_volume}</li>
							)}
							{propertyData?.sanborn_page && (
								<li><strong>Sanborn Page:</strong> {propertyData.sanborn_page}</li>
							)}
						</ul>
					</div>
				)}
			</div>
		</StandardModal>
	);
};

export default SanbornInfoModal;